import { render, staticRenderFns } from "./FormControlPagesComponentId.vue?vue&type=template&id=2f00502e"
import script from "./FormControlPagesComponentId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPagesComponentId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports